import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';

interface MePermissionsResponse {
  permissions: string[];
}

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `api/me/permissions`;
  private keys$?: Observable<string[]>;

  /** Vérifie si une clé donnée existe */
  isKeyInArray(key: string): Observable<boolean> {
    return this.loadKeys().pipe(map((keys) => keys.includes(key)));
  }

  /** Force le nettoyage des clefs (utile après login/logout) */
  cleanKeys(): void {
    this.keys$ = undefined;
  }

  /** Charge les clés depuis le back, mise en cache mémoire */
  loadKeys(): Observable<string[]> {
    if (!this.keys$) {
      this.keys$ = this.http.get<MePermissionsResponse>(this.apiUrl).pipe(
        map((res) => res?.permissions ?? []),
        // garde le résultat en mémoire tant que l'app tourne
        shareReplay(1),
        catchError((err) => {
          console.error('Erreur de récupération des clés :', err);
          return of([]);
        }),
      );
    }
    return this.keys$;
  }
}
